"use client"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Grid,
  Card,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
} from "@mui/material"
import {
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  Image as ImageIcon,
  People as PeopleIcon,
  Timer as TimerIcon,
  AttachMoney as AttachMoneyIcon,
  NotificationsActive as NotificationsActiveIcon,
  Checklist as ChecklistIcon, // Icône pour la check-liste
} from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ExitToAppIcon from "@mui/icons-material/ExitToApp"
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant"
import { GiHorseHead } from "react-icons/gi"
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';

const HomeAdmin = () => {
  const navigate = useNavigate()

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    })
    setTimeout(() => navigate("/login"), 4000) // Redirect after toast
  }

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs")
  }

  const handleProfile = () => {
    navigate("/ProfileAdmin")
  }

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        sx={{
          padding: "0.5rem",
          marginTop: "64px", // Espace sous le header (ajustez si nécessaire)
          backgroundColor: "#e0f7fa",
          height: "calc(100vh - 64px - 64px)", // 100vh - Header - Footer
          overflowY: "auto", // Permet le scroll interne si nécessaire
        }}
      >
        {/* Image principale */}
        <Card
          sx={{
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "transparent", // Supprime l'arrière-plan
            boxShadow: "none", // Supprime toute ombre indésirable
          }}
        >
          <img
            src={"../assets/ja.jpg"}
            alt="Club Équestre Jafoura"
            style={{
              width: "99%",
              borderRadius: "0px",
              height: "150px", // Diminuer la hauteur de l'image (ajuste la valeur selon tes besoins)
              objectFit: "cover", // Cela permet de maintenir le ratio sans déformer l'image
            }}
          />
        </Card>

        {/* Menu Items */}
        <Grid container spacing={1}>
          {/* Approuver un client */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#e8f5e9",
              }}
              onClick={() => navigate("/ApprouverClient")}
            >
              <PeopleIcon sx={{ fontSize: 20, color: "#388e3c" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Approuver un client
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#388e3c" }} />
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#ffebee",
              }}
              onClick={() => navigate("/AdminNotificationToClient")}
            >
              <NotificationImportantIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Envoyer une notification pérsonalisée
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
            </Card>
          </Grid>
          {/* Notifications */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#ffebee",
              }}
              onClick={() => navigate("/AdminNotification")}
            >
              <NotificationsActiveIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Notifications
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
            </Card>
          </Grid>
          {/* Changement du chrono */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#fff3e0",
              }}
              onClick={() => navigate("/AdminChrono")}
            >
              <TimerIcon sx={{ fontSize: 20, color: "#f57c00" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Changement du temps
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#f57c00" }} />
            </Card>
          </Grid>
          {/* Paiement client */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#e3f2fd",
              }}
              onClick={() => navigate("/AdminPaiment")}
            >
              <AttachMoneyIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Paiement client
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </Card>
          </Grid> <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#e3f2fd",
              }}
              onClick={() => navigate("/AdminVaccinsChevaux")}
            >
              <AttachMoneyIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                vaccination Paiement
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#fffde7",
              }}
              onClick={() => navigate("/ConsulterFactures")}
            >
              <NotificationsActiveIcon sx={{ fontSize: 20, color: "#fbc02d" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Consulter les factures
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#fbc02d" }} />
            </Card>
          </Grid>
          {/* Check-liste */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#fff3e0",
              }}
              onClick={() => navigate("/checklist")}
            >
              <ChecklistIcon sx={{ fontSize: 20, color: "#f57c00" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Check-liste
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#f57c00" }} />
            </Card>
          </Grid>
          {/* ClientsDash */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#fff3e0",
              }}
              onClick={() => navigate("/ClientsDash")}
            >
              <PeopleIcon sx={{ fontSize: 20, color: "#f57c00" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Consulter les Séances
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#f57c00" }} />
            </Card>
          </Grid>

          {/* DetailPension - NEW CARD */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#e8f5e9",
              }}
              onClick={() => navigate("/DetailPension")}
            >
              <GiHorseHead style={{ fontSize: 20, color: "#388e3c" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Détails des Pensions
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#388e3c" }} />
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#fff3e0",
              }}
              onClick={() => navigate("/Gestiondestock")}
            >
              <PeopleIcon sx={{ fontSize: 20, color: "#f57c00" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Gestion de stock
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#f57c00" }} />
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#fff3e0",
              }}
              onClick={() => navigate("/ConsulterStock")}
            >
              <PeopleIcon sx={{ fontSize: 20, color: "#f57c00" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Consulter le stock
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#f57c00" }} />
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#ffebee",
              }}
              onClick={() => navigate("/AdminBanner")}
            >
              <ImageIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Admin Banners
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
            </Card>
          </Grid>
          {/* Facture de concours */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#e8f5e9",
              }}
              onClick={() => navigate("/AdminCompetitionInvoice")}
            >
              <EmojiEventsIcon sx={{ fontSize: 20, color: "#388e3c" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Facture de concours
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#388e3c" }} />
            </Card>
          </Grid>
          
          <Grid item xs={12}>
  <Card
    sx={{
      display: "flex",
      alignItems: "center",
      padding: "1rem",
      cursor: "pointer",
      backgroundColor: "#e8f5e9",
    }}
    onClick={() => navigate("/suivichevaux")}
  >
    <MonitorWeightIcon sx={{ fontSize: 20, color: "#388e3c" }} />
    <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
      Suivi des chevaux
    </Typography>
    <MenuIcon sx={{ fontSize: 20, color: "#388e3c" }} />
  </Card>
</Grid>
 <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#ffebee",
              }}
              onClick={() => navigate("/AdminReservations")}
            >
              <ImageIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
              <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Admin Reservations
              </Typography>
              <MenuIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/Admin")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminPaiment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  )
}

export default HomeAdmin
  